import React from 'react'
import styles from './Venues.module.scss'

function Venues({ location }) {
	return (
		<p className={styles.venues}>
			<img src="/images/location.svg" alt="location" />
			<span>{location}</span>
		</p>
	)
}

export default Venues
